import { useReduxState } from 'hooks';
import { Button, RichTextValue } from 'components/common';
import { TextEditor } from 'components/editor/inputs';

interface Props {
  blockId: number;
  deleteIsDisabled?: boolean;
  index: number;
  isPreview?: boolean;
  onChange: (question: string, index: number) => void;
  onDelete: (index: number) => void;
  question: string;
}

const EditorBlockLikertQuestion = ({
  blockId,
  deleteIsDisabled = false,
  index,
  isPreview = false,
  onChange,
  onDelete,
  question
}: Props) => {
  const { messages } = useReduxState();

  const handleChange = (question: string) => onChange(question, index);

  const handleDelete = () => onDelete(index);

  return (
    <div
      className="question"
      id={`editor-block-likert-question-${blockId}-${index}`}
    >
      <div className="question-input">
        {isPreview ? (
          <RichTextValue
            html={question}
            style={{ width: '100%', padding: '5px' }}
          />
        ) : (
          <TextEditor
            ariaLabel={messages.editorBlockLikertStatements}
            content={question}
            onChange={handleChange}
            padding="5px"
            placeholder={messages.editorBlockLikertStatementAdd}
            style={{ width: '100%' }}
          />
        )}
      </div>
      <div className="delete">
        <Button
          aria-label={messages.commonDelete}
          data-tooltip={messages.commonDelete}
          category="lighter"
          disabled={isPreview || deleteIsDisabled}
          icon="trash-alt"
          onClick={handleDelete}
          size="small"
        />
      </div>

      <style jsx>{`
        .delete {
          flex-grow: 0;
          flex-shrink: 0;
          margin-left: 10px;
          margin-top: 1px;
        }
        .question {
          align-items: top;
          display: flex;
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 1.5rem;
          min-width: 0;
          background-color: white;
          border: 1px solid transparent;
          border-radius: 4px;
          padding: 5px 10px;
          transition: border-color 0.3s;
        }
        .question:focus-within {
          border-color: #a1a8aa;
        }
        .question:not(:first-child) {
          margin-top: 8px;
        }
        .question-input {
          flex-grow: 1;
          min-width: 0;
          align-items: top;
          display: flex;
          flex-direction: row;
          position: relative;
        }
        .question-input::before {
          counter-increment: likert-questions;
          content: counter(likert-questions) '.';
          display: inline-block;
          font-weight: 400;
          margin-top: 5px;
          margin-right: 5px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockLikertQuestion;
